import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { IonNav, ModalController, Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { SharedModule } from '@app/shared/shared.module';
import { SignDocumentBatchSandbox } from '@app/document-bundle-signing/sandboxes/sign-document-batch.sandbox';
import { SignDocumentPageComponent } from './pages/sign-document-page/sign-document-page.component';

@Component({
  selector: 'c-sign-document-batch-modal',
  imports: [SharedModule],
  providers: [IonNav],
  templateUrl: './sign-document-batch-modal.component.html',
  styleUrl: './sign-document-batch-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignDocumentBatchModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() documentBatchId: string;

  @ViewChild('ionNav') ionNav: IonNav;

  readonly sandbox = inject(SignDocumentBatchSandbox);
  private readonly modalCtrl = inject(ModalController);
  private readonly platform = inject(Platform);

  private viewReady = false;
  private rootSet = false;
  private backButtonSubscription: Subscription;

  constructor() {
    effect(() => {
      // Re-runs whenever the documents signal changes; setRoot once both the
      // batch has loaded and the ion-nav view is ready.
      this.sandbox.documents();
      this.trySetNavRoot();
    });
  }

  ngOnInit(): void {
    this.sandbox.loadBatch(this.documentBatchId);
  }

  ngAfterViewInit(): void {
    this.viewReady = true;
    this.trySetNavRoot();
    this.subscribeToHardwareBackButton();
  }

  ngOnDestroy(): void {
    this.backButtonSubscription?.unsubscribe();
    this.sandbox.cleanup();
  }

  private trySetNavRoot(): void {
    if (this.rootSet || !this.viewReady || this.sandbox.documents().length === 0) {
      return;
    }
    this.rootSet = true;
    this.ionNav.setRoot(SignDocumentPageComponent, { index: 0 });
  }

  private subscribeToHardwareBackButton(): void {
    this.backButtonSubscription = this.platform.backButton.subscribeWithPriority(101, () => {
      this.ionNav.canGoBack().then((canGoBack) => {
        if (canGoBack) {
          this.ionNav.pop();
        } else {
          this.modalCtrl.dismiss();
        }
      });
    });
  }
}
